// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatakbtc } from "../../../icons/mono/build/icon-statakbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatakbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatakbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatakbtcIcon.displayName = 'StatakbtcIcon';
}

export default StatakbtcIcon;